import { Badge, theme, Typography } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'
import React, { memo } from 'react'
import { useIntl } from 'react-intl'

const { Text } = Typography

const pillStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '1px 10px',
  borderRadius: 999,
  flexShrink: 0,
  whiteSpace: 'nowrap',
}

/** Pill status shift: "Berjalan" (dot berdenyut) atau "Selesai". */
const ShiftStatusPill = ({ isOpen }) => {
  const { formatMessage } = useIntl()
  const { token } = theme.useToken()

  if (isOpen) {
    return (
      <span
        style={{
          ...pillStyle,
          background: token.colorSuccessBg,
          border: `1px solid ${token.colorSuccessBorder}`,
        }}
      >
        <Badge status="processing" color={token.colorSuccess} />
        <Text style={{ fontSize: 12, fontWeight: 600, color: token.colorSuccessText }}>
          {formatMessage({ id: 'shift_status_open' })}
        </Text>
      </span>
    )
  }

  return (
    <span
      style={{
        ...pillStyle,
        background: token.colorFillTertiary,
        border: `1px solid ${token.colorBorderSecondary}`,
      }}
    >
      <CheckCircleOutlined style={{ fontSize: 12, color: token.colorTextTertiary }} />
      <Text type="secondary" style={{ fontSize: 12, fontWeight: 600 }}>
        {formatMessage({ id: 'shift_status_closed' })}
      </Text>
    </span>
  )
}

export default memo(ShiftStatusPill)
